<template>
  <div>
    <v-card class="box">
    <v-row fluid justify="center">        
      <v-radio-group v-model="print_type" row @change="clearTables()">
        <v-radio label="Print Bulk" value="Bulk" color="success"></v-radio>
        <v-radio
          label="Print Specific Students / Parents"
          value="Specific"
          color="success"
        ></v-radio>
      </v-radio-group>
    </v-row>

    <template v-if="print_type == 'Bulk'">
      
        <v-row justify="center">
          <v-col sm="3" md="3">
            <v-autocomplete
              class="no-display"
              :items="academic_year_list"
              item-value="ay_id"
              item-text="academicyear"
              v-model="ay"
              label="Select Ay"
              dense
              rounded
              outlined
              :loading="comp_load"
              color="#0F2027"
            ></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete
              class="no-display"
              :items="std_list"
              item-value="id"
              item-text="standard"
              v-model="std"
              @change="getDivisions(std)"
              label="Search Standard"
              dense
              rounded
              outlined
              color="#0F2027"
            ></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3" v-if="div_list != ''">
            <v-autocomplete
              class="no-display"
              :items="div_list"
              item-value="id"
              item-text="division"
              v-model="div"
              label="Search Division"
              dense
              rounded
              outlined
              color="#0F2027"
            ></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="status"
              :items="status_list"
              item-text="name"
              item-value="id"
              label="Status"
              outlined
              persistent-hint
              hint="Select Status"
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col sm="3" md="3">
            <v-btn v-if="ay && std && div" color = "primary" @click="bulk"
              >Proceed to bulk <span class="i-card"> Student</span> icard
              print</v-btn
            >
          </v-col>
          <v-col v-if="ay && std && div" sm="3" md="3">
            <v-btn color = "primary" @click="bulk_parent"
              >Proceed to bulk <span class="i-card"> Parent</span> icard
              print</v-btn
            >
          </v-col>
          <v-col v-if="ay && std && div" sm="3" md="3">
            <v-btn color = "primary" @click="getIcardIssueDate()"
              >Get Icard Issue Report</v-btn
            >
          </v-col>
        </v-row>
      
    </template>
    <template v-if="print_type == 'Specific'">
        <br />
        <v-row justify="center" dense>
          <v-col sm="5">
            <v-textarea
              v-model="prn"
              color="#0F2027"
              rounded
              dense
              label="Enter Comma Seperated PRN"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="3" v-if="prn">
            <v-btn color = "primary" @click="getIcardsSpecificPRN()"
              >Proceed To <span class="i-card"> Student</span> Icard
              print</v-btn
            >
          </v-col>
          <v-col sm="3" v-if="prn">
            <v-btn color = "primary" @click="getParentIcardsSpecificPRN()"
              >Proceed To <span class="i-card"> Parent</span>Icard print</v-btn
            >
          </v-col>
          <v-col sm="3" md="3" v-if="prn">
            <v-btn color = "primary" @click="getIcardIssueDate()"
              >Get Icard Issue Report</v-btn
            >
          </v-col>
        </v-row>
        <br>
    </template>
    </v-card>
    <v-card class="box" v-if="learner_data_specific != '' && print_type === 'Specific'">
    <v-toolbar class="toolbar" flat dense v-if="learner_data_specific != ''">
      <v-toolbar-title>
        <strong> Icard Issue Report </strong>
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      v-if="learner_data_specific != ''"
      dense
      :headers="headers"
      :items-per-page="-1"
      :items="bookList1"
      :search="search"
      class="elevation-1 mytable"
      @current-items="getFiltered"
    >
      <template v-slot:top class="pb-5">
        <v-row justify="center" align="center" dense>
          <tr class="t-row">
            <div>
              <th>
                <v-col cols="12" sm="12" md="12">
                  <v-row dense>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete
                          class="mr-2 pb-5 pt-2 no-display"
                          flat
                          hide-details
                          small
                          rounded
                          dense
                          outlined
                          color="#0F2027"
                          :label="header.text"
                          multiple
                          clearable
                          :items="columnValueList(header.value)"
                          v-model="filters[header.value]"
                        ></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </v-col>
              </th>
            </div>
          </tr>
        </v-row>
      </template>
      <template v-slot:item.issue_data="{ item }">
        <v-row v-for="(id, index) in item.issue_data" :key="index">
          <strong>{{ index + 1 }}) Issue Date - </strong> {{ id.issue_date }}
          <strong class="pl-5"> Issue Count - </strong> {{ id.count }}
        </v-row>
      </template>
    </v-data-table>
    </v-card>
    <v-card class="box" v-if="learner_data_bulk != '' && print_type === 'Bulk'">
    <v-toolbar class="toolbar" flat dense v-if="learner_data_bulk != ''">
      <v-toolbar-title>
        <strong> Icard Issue Report </strong>
      </v-toolbar-title>
    </v-toolbar>
    <v-data-table
      v-if="learner_data_bulk != ''"
      dense
      :headers="headers"
      :items-per-page="-1"
      :items="bookList1"
      :search="search"
      class="elevation-1 mytable"
      @current-items="getFiltered"
    >
      <template v-slot:top class="pb-5">
        <v-row justify="center" align="center" dense>
          <tr class="t-row">
            <div>
              <th>
                <v-col cols="12" sm="12" md="12">
                  <v-row dense>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete
                          class="mr-2 pb-5 pt-2 no-display"
                          flat
                          hide-details
                          small
                          rounded
                          dense
                          outlined
                          color="#0F2027"
                          :label="header.text"
                          multiple
                          clearable
                          :items="columnValueList(header.value)"
                          v-model="filters[header.value]"
                        ></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </v-col>
              </th>
            </div>
          </tr>
        </v-row>
      </template>
      <template v-slot:item.issue_data="{ item }">
        <v-row v-for="(id, index) in item.issue_data" :key="index">
          <strong>{{ index + 1 }}) Issue Date - </strong> {{ id.issue_date }}
          <strong class="pl-5"> Issue Count - </strong> {{ id.count }}
        </v-row>
      </template>
    </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    prn: "",
    comp_load: false,
    stud_list: null,
    radios: null,
    radios1: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    print_type: null,
    std_list: null,
    div_list: null,
    std: null,
    div: null,
    for: null,
    usertype: null,
    learner_data_bulk: [],
    learner_data_specific: [],
    report_load:false,
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    filters: {
      name: [],
      prn: [],
    },
    filterArr: [],
    status: "0",
    active_status: null,
    academic_year_list: [],
    ay: "",
    icard_data: [],
    common_data: [],
    headers: [
      { text: "Student", value: "name", sortable: false },
      { text: "Registration No.", value: "prn", sortable: false },
      { text: "Roll No.", value: "rollno", sortable: false },
      { text: "Division", value: "div", sortable: false },
      { text: "Issue Data", value: "issue_data", sortable: false },
    ],
  }),
  computed: {
    bookList1() {
        let data = this.print_type === 'Bulk' ? this.learner_data_bulk : this.learner_data_specific;

        return data.filter((d) => {
        return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
        });
      }
    },
  mounted() {
    this.onload();
    localStorage.setItem("icard_data", null);
    localStorage.setItem("common_data", null);
  },
  methods: {
    clearTables() {
        this.learner_data_bulk = [];
        this.learner_data_specific = [];
    },
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {        
        const data = this.print_type === 'Bulk' ? this.learner_data_bulk : this.learner_data_specific;
        if (!Array.isArray(data)) return [];

        // Get unique values only
        return [...new Set(data.map((d) => d[val]).filter((v) => v != null))];
    },
    getDivisions(standard) {
      this.payment_data = null;
      const data = {
        ay: this.ay,
        standard: standard,
      };
      this.overlay = true;
      axios
        .post("/admission/getDivisionOfferings", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.div_list = res.data.div_off_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    bulk() {
      localStorage.setItem("icard_ay_id", this.ay);
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "sbpps-student-bulk-card-print",
      });
      window.open(routeData.href, "_blank");
    },
    bulk_parent() {
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "sbpps-bulk-parent-card-print",
      });
      window.open(routeData.href, "_blank");
    },
    getIcardIssueDate() {
      const data = {
        std: this.std,
        div: this.div,
        status: this.status,
        ay: this.ay,
        learners: this.print_type === 'Specific' ? this.prn : null,
      };
      this.report_load = true;
      axios
        .post("/Icard/getIcardIssueDate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            if (this.print_type === 'Specific') {
                this.learner_data_specific = res.data.learner_data;
                this.learner_data_bulk = []; // clear other
            } else {
                this.learner_data_bulk = res.data.learner_data;
                this.learner_data_specific = []; // clear other
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong...");
        })
        .finally(() => {
            this.report_load = false;
        });
    },
    onload() {
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents1")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
            this.std_list = res.data.std_list;
            this.div_list = res.data.div_list;
            this.academic_year_list = res.data.academic_year_list;
            this.ay = res.data.current_ay;
          } else {
            alert("Something went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Something went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getIcardsSpecificPRN() {
      localStorage.setItem("prn", JSON.stringify(this.prn));
      let routeData = this.$router.resolve({
        name: "sbpps-stud-specific-card-print",
      });
      window.open(routeData.href, "_blank");      
    },
    getParentIcardsSpecificPRN() {
      localStorage.setItem("prn", JSON.stringify(this.prn));
      let routeData = this.$router.resolve({
        name: "sbpps-specific-parent-card-print",
      });
      window.open(routeData.href, "_blank");     
    },
  },
};
</script>
<style scoped>
.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
